import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { ModalManagementService } from '@wdx/clmi/ui';
import { RandomStringPipe } from '../../../../pipes/random-string.pipe';
import {
    TRANSLATION_COMMENTS_LABEL,
    TranslationsService,
} from '@wdx/shared/utils';

@Component({
    selector: 'clmi-comments-modal',
    templateUrl: './comments-modal.component.html',
    styleUrls: ['./comments-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CommentsModalComponent {
    private translationsService = inject(TranslationsService);

    modalId: string;
    set modalTitle(title: string) {
        this._modalTitle = title;
    }
    get modalTitle(): string {
        const commentsLabel = this.translationsService.getTranslationByKey(
            TRANSLATION_COMMENTS_LABEL,
        );
        return this._modalTitle
            ? `${this._modalTitle} ${commentsLabel}`
            : commentsLabel;
    }

    _modalTitle: string;
    entityId: string;
    entityType: SystemEntity = SystemEntity.Activity;
    commentSource?: string;

    constructor(private modalManagementService: ModalManagementService) {
        this.modalId = new RandomStringPipe().transform();
    }

    open(): void {
        this.modalManagementService.openModalWithId(this.modalId);
    }

    close(): void {
        this.modalManagementService.closeActiveModal();
    }
}
